const styles = {
  canceButton: {
    color: '#323232',
    fontSize: 16,
    fontWeight: 'bold' as 'bold',
    letterSpacing: 1.25,
  },
  submitButton: {
    height: 40,
    width: 155,
    borderRadius: 3,
    backgroundColor: '#463264',
    fontSize: 16,
    color: '#FFFFFF',
    fontWeight: 'bold' as 'bold',
    letterSpacing: 1.25,
  },
  paper: {
    borderRadius: 5,
    maxHeight: 680,
    minHeight: 550,
    minWidth: 350,
    padding: 0,
    display: 'flex',
    justifyContent: 'center' as 'center',
  },
  title: {
    alignItems: 'center' as 'center',
    display: 'flex',
    flexDirection: 'row' as 'row',
    fontSize: 36,
    color: '#323232',
    justifyContent: 'center' as 'center',
    paddingBottom: 0,
  },
  leftDot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: '#eb6565',
    marginRight: 15,
  },
  rightDot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: '#eb6565',
    marginLeft: 15,
  },
  contentStyle: {
    margin: '0 auto',
  },
  formField: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 35,
  },
  controlsRow: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row' as 'row',
    fontSize: 14,
    margin: 5,
  },
  controlsBullet: {
    backgroundColor: 'black',
    borderRadius: '50%',
    height: 5,
    marginRight: 15,
    width: 5,
  },
  mobileImageStyle: {
    alignItems: 'center',
    display: 'flex',
    margin: '0 auto',
    marginTop: 25,
  },
  stepContainer: {
    margin: '15px 0',
  },
};

export default styles;
